
































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import ChoiceFactorInput from "@/components/choice-input/ChoiceFactorInput.vue";
import ChoiceInputFormGrowingTable from "@/components/choice-input/form/ChoiceInputFormGrowingTable.vue";
import ChoiceInputFormFixedTable from "@/components/choice-input/form/ChoiceInputFormFixedTable.vue";
import { ChoiceInputFactorResource } from "@/types/ChoiceInputFactorResource";

@Component(
    {
        name: 'ChoiceInputFormRecursiveGroupComp',
        components: {
            ChoiceInputFormFixedTable,
            ChoiceInputFormGrowingTable,
            ChoiceFactorInput
        }
    })
export default class ChoiceInputFormRecursiveGroup extends Vue {

    @Prop()
    elements!: string[];

    @Prop()
    factorResources!: { [id: string]: ChoiceInputFactorResource }

    @Prop()
    choiceForm!: any;

    @Prop({
        type: Object,
        default: () => ({})
    })
    styles!: any;

    @Prop({type: Number, default: 0})
    depth!: number;

    private nextDepth: number = this.depth + 1;

    get visibilityMap() {
        return this.elements.map(id => this.factorResources[id])
            .filter(f => f.visibilityDefinition)
            .reduce((map: any, obj: ChoiceInputFactorResource) => (map[obj.id] = this.isVisible(obj), map), {});
    }

    private isVisible(factor: ChoiceInputFactorResource) {

        if (!factor.visibilityDefinition || !factor.visibilityDefinition.factorIds.length) {
            return true;
        }
        let data = factor.visibilityDefinition.factorIds.map(id => this.factorResources[id])
            .filter(f => f)
            .map(f => this.choiceForm[f.dataField || ''])

        if (!data.length) return true;

        switch (factor.visibilityDefinition.conditionalFunction) {
            case "ALL_EXISTS":
                return data.filter(d => !!d).length === data.length
            case "ANY_EXISTS":
                return data.filter(d => !!d).length
            case "NONE_EXISTS":
                return !data.filter(d => !!d).length
        }

    }

}
